import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AppShell } from '@/components/layout';

// Lazy load route components
const GamePage = React.lazy(() => import('./GamePage'));
const StatsPage = React.lazy(() => import('./StatsPage'));
const AboutPage = React.lazy(() => import('./AboutPage'));
const SettingsPage = React.lazy(() => import('./SettingsPage'));
const OfflinePage = React.lazy(() => import('./OfflinePage'));
const HomePage = React.lazy(() => import('./HomePage'));

// Loading component
const LoadingSpinner: React.FC = () => (
  <div className='flex items-center justify-center min-h-screen'>
    <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600'></div>
  </div>
);

const AppRoutes: React.FC = () => {
  return (
    <AppShell>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path='/' element={<GamePage />} />
          <Route path='/home' element={<HomePage />} />
          <Route path='/stats' element={<StatsPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/settings' element={<SettingsPage />} />
          <Route path='/offline' element={<OfflinePage />} />
        </Routes>
      </Suspense>
    </AppShell>
  );
};

export default AppRoutes;
